import { useQuery } from '@tanstack/react-query'
import getWhatsNewTour from '../api/whatsnew/getWhatsNewTours'
import { TourResponse } from '../types/tourResponse'
import { GET_WHATS_NEW_TOURS_KEY } from '../constants/queryKeys'

const useWhatsNewTour = (enabled = false) => {
  return useQuery<TourResponse>(
    [GET_WHATS_NEW_TOURS_KEY as any],
    () => getWhatsNewTour(),
    { enabled },
  )
}

export default useWhatsNewTour
